module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAORJREFUKFN1kt1tg0AQhGcQLcS+HnhIDXQQjCw/2BUQKRVECj1ESg2JLOMOkiZMD5CU4J+J7nzGgI57vNvZmf32KJMnwOUdiFdstn8IHJlFaa/ZVCVlsm9IKcgaiNOxSObpDUIJ8AxGj5RZPgCnH0jJWDQoBtdsqy9aq5AIOBZdZ2DDdv/pYt0ia57NQNh41ukX0szF6BUPBD2nw7XYtoue2VQffQ6dw1VwG9CXBEDcIw1o8AVQEQLhh+6h85mn6HGI7k5jih7dFqVXeM7jRXdO7iFOfaQ8YbOrQ9/COTnksewv+AdPmIqk1h/gcAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-wrong-red.png
// module id = PY/O
// module chunks = 129